import { render, staticRenderFns } from "./test.vue?vue&type=template&id=7ffa6a5c&scoped=true&"
import script from "./test.vue?vue&type=script&lang=ts&"
export * from "./test.vue?vue&type=script&lang=ts&"
import style0 from "./test.vue?vue&type=style&index=0&id=7ffa6a5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa6a5c",
  null
  
)

export default component.exports